import React, { useCallback, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";

import { environment } from "../../..";
import ConnectionCheck from "../connectionCheck";
import { handleError } from "../../../modules/errorLogger";
import { checkHttpStatus, get } from "../../../modules/httpFunctions";

import "./index.css";

const prodEnvironments = ["prod", "iprd"];
const defaultClass = "background-overlay";
const id = "environment-div";

const useStyles = createUseStyles({
  environment: (props) => ({
    height: props.height,
  }),
});

const EnvironmentBackground = () => {
  const [environmentClass, setEnvironmentClass] = useState(defaultClass);
  const [production, setProduction] = useState(true);
  const [healthData, setHealthData] = useState();
  const handleDataLoad = useCallback(() => {
    get("health")
      .then((r) => {
        if (checkHttpStatus(r)) {
          const { data } = r;
          const env = environment || "prod";
          setEnvironmentClass(
            `${defaultClass} background-${
              env === "test"
                ? "test"
                : env === "edge"
                ? "edge"
                : env === "sdpt"
                ? "sandpit"
                : ""
            }`
          );
          setProduction(env ? prodEnvironments.includes(env) : true);
          setHealthData(data);
        } else {
          setEnvironmentClass(defaultClass);
          setProduction(true);
          setHealthData("e");
        }
      })
      .catch((err) => {
        setEnvironmentClass(defaultClass);
        setProduction(true);
        setHealthData("e");
        handleError(err);
      });
  }, []);

  useEffect(() => {
    handleDataLoad();
  }, [handleDataLoad]);

  const [height, setHeight] = useState();
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.length > 0 &&
        setHeight(`${entries[0].contentRect.height + 320}px`);
    });
    resizeObserver.observe(
      document.getElementsByClassName("app-content").item(0)
    );
    return () => resizeObserver.disconnect();
  }, []);

  const classes = useStyles({ height });

  return (
    <>
      <ConnectionCheck healthData={healthData} onDataLoad={handleDataLoad} />
      {production ? (
        <></>
      ) : (
        <div
          id={id}
          className={`${environmentClass} ${classes.environment}`}
        ></div>
      )}
    </>
  );
};

export default EnvironmentBackground;
